import { render, staticRenderFns } from "./PriceSnapshotListPage.vue?vue&type=template&id=41163b93&"
import script from "./PriceSnapshotListPage.vue?vue&type=script&lang=ts&"
export * from "./PriceSnapshotListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports